import type { AvatarColor } from "../modules/shared/types";
import { hashCode } from "./hash";

const AVATAR_COLORS: readonly AvatarColor[] = [
  "orange",
  "blue",
  "green",
  "red",
  "purple",
  "pink",
];

export function toAvatarColor(color: string): AvatarColor {
  return AVATAR_COLORS.includes(color as AvatarColor)
    ? (color as AvatarColor)
    : "blue";
}

export function pickAvatarColor(key: string): AvatarColor {
  return AVATAR_COLORS[Math.abs(hashCode(key)) % AVATAR_COLORS.length] ?? "blue";
}
